import { useEffect } from 'react'
import NProgress from 'nprogress'

import './header.css'

import { getPrivateMode, setMobileSidebar, setPrivateMode, useMobileSidebar, usePrivateMode } from '../state/ui'
import { connectWs } from '../state/ws'
import { Visibility, VisibilityOff } from '@nine-thirty-five/material-symbols-react/sharp'
import { castSend } from '../tools/cast'

interface HeaderProps {
  title: string
}

function Header(props: HeaderProps) {
  const mobileSidebar = useMobileSidebar()
  const privateModeOn = usePrivateMode()
  const { title } = props

  useEffect(() => {
    // @ts-ignore
    window.__onGCastApiAvailable = (isAvailable: any) => {
      if (isAvailable) {
        // @ts-ignore
        window.cast.framework.CastContext.getInstance().setOptions({
          receiverApplicationId: '80EB6972'
        })
        // @ts-ignore
        const player = new window.cast.framework.RemotePlayer()
        // @ts-ignore
        const controller = new window.cast.framework.RemotePlayerController(player)

        controller.addEventListener(
          // @ts-ignore
          window.cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED,
          (event: any) => {
            if (event.field === 'isConnected' && event.value) {
              castSend({
                type: 'auth',
                data: {
                  token: window.localStorage.token,
                  privateMode: getPrivateMode()
                }
              })
            }
          }
        )
      }
    }
  }, [])

  useEffect(() => {
    const script = document.createElement('script')

    script.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1'
    script.async = true
    document.body.appendChild(script)

    NProgress.configure({
      parent: '.nprogress-container',
      template: '<div class="bar" role="bar"><div class="peg"></div></div>',
      showSpinner: false,
      trickle: false
    })
  }, [])

  function menu() {
    setMobileSidebar(!mobileSidebar)
    console.log('Sidebar', mobileSidebar)
  }

  function privateMode() {
    setPrivateMode(!getPrivateMode())
    connectWs()
  }

  return (
    <div className="header">
      <div className="nprogress-container" />
      <div className="bar">
        <button className="menu-icon" onClick={menu}>
          Menu
        </button>
        <div className="name">{title}</div>
        <div className="icons">
          <button onClick={privateMode}>
            {privateModeOn ? <VisibilityOff size={24} /> : <Visibility size={24} />}
          </button>
          {navigator.userAgent.includes('Chrome') && (
            <button
              className="cast-button"
              is="google-cast-button"
              style={{
                margin: '6px',
                width: '30px',
                height: '30px',
                float: 'right'
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
